<template>
  <div class="login">
    <div class="header-container">
      <div class="header">
        <img class="logo" src="../assets/logo-1.png?v20260623">
      </div>
    </div>
    <div class="login-main">
      <div class="login-box">
        <div class='login-qr' id="login_container"></div>
        <p class="text">· 深圳市“新课程 新课堂”单元教学资源包、录像课例获奖作品指定展示平台&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;· 深圳市“演中学”课本剧剧本和录像获奖作品指定展示平台</p>
      </div>
    </div>
    <div class="foot-container login-footer">
      <!-- 深圳市教育科学研究院 中小幼教研中心 -->
      <div class="foot">Copyright©2023 深圳市小学英语教研中心组</div>
    </div>
  </div>
</template>

<script>
import config from '../config.js'
import api from '../utils/api.js'
let WxLogin = window.WxLogin
export default {
  name: 'Login',
  data () {
    return {

    }
  },
  mounted () {
    if (JSON.parse(localStorage.getItem('newAjaxHeader'))) {
      location.hash = '/index'
    } else {
      var url = location.protocol + '//' + location.host + location.pathname + '#/'
      // if (window.localStorage) {
      //   window.localStorage.clear()
      // }
      /* eslint-disable no-new */
      new WxLogin({
        self_redirect: false,
        id: 'login_container',
        appid: config.appId,
        scope: 'snsapi_login',
        redirect_uri: encodeURIComponent(url),
        // redirect_uri: encodeURIComponent('https://szteacher.kingsunedu.com/#/'),
        state: '',
        style: '',
        /* 登录页面二维码样式 需要手动更新cdn和版本号 */
        // href: 'https://fzszteacher.oss-cn-shenzhen.aliyuncs.com/static/css/qr.css',
        href: 'https://szteacher.kingsunedu.com/static/css/qr.css',
        // 禁止微信快速登录
        fast_login: 0
      })
    }
    // IE兼容性处理
    if (this.checkIE()) {
      const self = this
      // 使用addEventListener来覆盖window原有的hashchange处理方法
      window.addEventListener('hashchange', () => {
        const currentPath = window.location.hash.slice(1)
        if (self.$route.fullPath !== currentPath) {
          self.$router.push(currentPath)
        }
      }, false)
    }
    // 二维码区域
    // this.setQr()
    // this.resize()
  },
  methods: {
    wxlogin (wxCode) {
      api.login(
        wxCode,
        res => {
          // this.$router('/index')
        },
        () => {
          this.loadingInstance.close()
        }
      )
      // console.log(wxCode)
    },
    checkIE () {
      return '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style
    }
    // setQr () {
    //   let qrwidth = (document.documentElement.clientWidth - 960) / 2 + 960 - 300 - 50
    //   this.codel = qrwidth
    //   this.codet = document.documentElement.clientHeight / 1080 * 100 + 100
    //   this.codew = document.documentElement.clientWidth / 1920 * 300
    //   this.codeh = this.codew * 350 / 300
    //   document.querySelector('iframe').style.width = this.codew + 'px'
    //   document.querySelector('iframe').style.height = this.codeh + 30 + 'px'
    // },
    // // 页面变化
    // resize () {
    //   let _this = this
    //   window.addEventListener('resize', function () {
    //     _this.setQr()
    //   })
    // }
  },
  watch: {
    $route (to, from) {
      if (to.query.code) {
        this.wxlogin(to.query.code)
      }
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.login{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.header-container {
  width: 100%;
  height: 100px;
  background: #fff;
}
.header {
  width: 960px;
  margin: 0 auto;
  height: 100px;
}
.header .logo {
  width: 359px;
  height: 60px;
}
.login-main{
  width: 100%;
  height: 707px;
  margin: 0 auto;
  background: transparent url('../assets/login_bg.jpg?v20190724') center bottom no-repeat;
  background-size: 1680px 707px;
}
.login-box {
  position: relative;
  width: 960px;
  height: 100%;
  margin: 0 auto;
}
.login-qr{
  position: absolute;
  top: 100px;
  right: 35px;
  width: 300px;
  height: 350px;
  background: #fff;
  text-align: center;
}
.impowerBox .info {
  width: auto;
}
.login-footer {
  height: 130px;
  line-height: 130px;
  text-align: center;
}
.login-footer .foot {
  font-size: 15px;
}
.login-box .text {
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 960px;
  height: 59px;
  line-height: 59px;
  color: #eee;
  font-size: 13px;
  text-align: center;
  transform: translateX(-50%);
  margin: 0;
}
@media screen and (max-width: 1366px) {
  .login-qr{
    background: #ccc;
  }
}
</style>
